export default __webpack_public_path__ + "static/media/regen.84ea628c.webp";